// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3HMBl","selected":"Chip_selected__2QSWy"};